import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => setLanguage('ru')}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
          language === 'ru'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        RU
      </button>
      <button
        onClick={() => setLanguage('uz')}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
          language === 'uz'
            ? 'bg-white text-primary-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        UZ
      </button>
    </div>
  );
};

export default LanguageSwitcher;
